"use es6";

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import P from "../components/Text/P";
import H1 from "../components/Text/H1";
import SearchHub from "../components/SearchHub/SearchHub";
import Loading from "../components/Loading/Loading";
import Button from "../components/Buttons/Button";

import sfh_wordmark2 from "../graphics/branding/sfh_wordmark2.svg";
import H3 from "../components/Text/H3";

const HomePage = ({
  isDesktop = null,
  translation = null,
  activePage = null,
  setActivePage = {},
  dimensions = null,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div style={{ flex: 1 }}>
      {!!translation && dimensions ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            justifyContent: "center",
            width: isDesktop && dimensions.width - 290,
          }}
        >
          <div style={{ marginBottom: 20 }}>
            <SearchHub
              isDesktop={isDesktop}
              translation={translation}
              setActivePage={setActivePage}
            />
          </div>

          <div
            style={{
              textAlign: "left",
              margin: "auto",
              maxWidth: isDesktop ? 600 : dimensions.width - 20,
              marginBottom: 60,
            }}
          >
            <img
              src={sfh_wordmark2}
              style={{
                width: "100%",
                paddingBottom: isDesktop && 5,
              }}
              onClick={() => {
                navigate("/");
                setActivePage("");
              }}
            />
            <br />
            <br />
            <P style={{ marginBottom: 10 }}>
              {translation.homepage.description}
            </P>
            <H1
              style={{
                textAlign: "center",
                fontStyle: "italic",
                marginBottom: 20,
              }}
            >
              Join the cause today!
            </H1>
            
            <br />
            <Button
              type="solid"
              style={{ textAlign: "center", marginTop: 10, marginBottom: 20 }}
              onClick={() => {
                navigate("/policy");
                setActivePage("");
              }}
            >
              {translation.navigation.privacy_policy}
            </Button>
          </div>
        </div>
      ) : (
        <Loading
          style={{
            position: "fixed",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      )}
    </div>
  );
};

export default HomePage;
